"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var dashboard_1 = __importDefault(require("./dashboard"));
var instance_1 = __importDefault(require("./instance"));
var permission_1 = __importDefault(require("./permission"));
var entity_generator_1 = __importDefault(require("./entity-generator"));
var SuperAdmin = function (_a) {
    var apiUrl = _a.apiUrl, entities = _a.entities, mockData = _a.mockData, disableAssetsRefresh = _a.disableAssetsRefresh, props = __rest(_a, ["apiUrl", "entities", "mockData", "disableAssetsRefresh"]);
    return (react_1["default"].createElement(react_router_dom_1.Switch, null,
        react_1["default"].createElement(react_router_dom_1.Route, { path: props.urlPrefix + "/instance" },
            react_1["default"].createElement(instance_1["default"], __assign({}, props))),
        react_1["default"].createElement(react_router_dom_1.Route, { path: props.urlPrefix + "/permission" },
            react_1["default"].createElement(permission_1["default"], __assign({}, props))),
        react_1["default"].createElement(react_router_dom_1.Route, { path: props.urlPrefix + "/entity" },
            react_1["default"].createElement(entity_generator_1["default"], __assign({ apiUrl: apiUrl, entities: entities, mockData: mockData }, props))),
        react_1["default"].createElement(react_router_dom_1.Route, { path: "" + props.urlPrefix },
            react_1["default"].createElement(dashboard_1["default"], __assign({ disableAssetsRefresh: disableAssetsRefresh }, props)))));
};
exports["default"] = SuperAdmin;
